import React, { useState, useEffect } from 'react'

// Deps
import { connect } from 'react-redux'

// Partials
import Btn from 'views/shared/partials/btn'
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Loader from 'views/shared/partials/loader'
import Collapser from 'views/shared/partials/collapser'

// Services
import companyServices from 'services/company'
import userServices from 'services/user'

// Hooks
import useGroups from 'hooks/groups'

const mapStateToProps = (state, ownProps) => {
	return {
		userGroups: state.user.groups,
		userData: state.user.data,
	};
};

const AccountModal = ({userData, accountID, close, ...props}) => {
	const [submitting, setSubmitting] = useState(false);
	const [accountInfo, setAccountInfo] = useState(false);
	const [ownerOption, setOwnerOption] = useState(false);
	const [terminalOption, setTerminalOption] = useState(false);
	const [changePassword, setChangePassword] = useState(false);
	const [userGroups, setUserGroups] = useState(false)
	const [defaultUserGroup, setDefaultUserGroup] = useState(false);

	const groups = useGroups(props.userGroups, false);

	useEffect(() => {
		if(accountID) {
			companyServices.getAccount(accountID).then((accountPayload) => {

				companyServices.listGroups({
					per_page: 9999,
					sort_by: 'created_at',
					company_account_code: accountID,
				}).then((groupsPayload) => {
					accountPayload.groups = groupsPayload.groups.map((group) => {
						return { value: group.store_code, label: group.name }
					});
					
					setOwnerOption(accountPayload.is_owner);
					setTerminalOption(accountPayload.is_terminal);
					setUserGroups(accountPayload.groups);
					setAccountInfo(accountPayload);
					if(accountPayload.default_group) {
						setDefaultUserGroup({...accountPayload.default_group, value: accountPayload.default_group.store_code, label: accountPayload.default_group.name});
					}
				}).catch((error) => {
					close();
				});
			}).catch(() => {
				close();
			})
		}
		else {
			setAccountInfo(null);
		}
	}, [accountID, close]);

	useEffect(() => {
		if(defaultUserGroup && userGroups) {
			if(!userGroups.find((group) => group.value === defaultUserGroup.value)){
				setDefaultUserGroup(null);
			}
		}
	}, [userGroups, defaultUserGroup])

	const submit = (formData) => {
		setSubmitting(true);

		if(accountInfo) {
			formData.company_account_code = accountID;
			formData.create_or_update = 'update';
		}
		else {
			formData.create_or_update = 'create';
		}

		if(!formData.status) {
			formData.status = "0";
		}
		if(!formData.is_owner) {
			formData.is_owner = "0";
		}
		if(!formData.is_group_report) {
			formData.is_group_report = "0";
		}
		if(!formData.is_group_clients) {
			formData.is_group_clients = "0";
		}
		if(!formData.is_super_user) {
			formData.is_super_user = "0";
		}

		companyServices.createOrUpdateAccount(formData).then((payload) => {
			if(payload.id === userData.id) {
				userServices.setUserData(payload, true);
			}

			if(props.onSuccess) {
				props.onSuccess();
			}
			close();
		}).catch(() => {
		}).finally(() => {
			setSubmitting(false);
		})
	}

	return (
		<InputForm
			ignoreEmpty
			onSubmit={submit}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">{accountID ? 'Kullanıcı Hesabı Düzenle' : 'Kullanıcı Hesabı Oluştur'}</h1>
				{props.closeBtn}
			</div>

			<div className="modal-content loader-container">
				<Loader loading={accountInfo === false} />
				<div className="grid-container">
					<div className="row">
						<div className="col x6">
							<FormInput
								type="text"
								disabled={accountInfo === false || submitting}
								label="Yetkili Adı"
								autoComplete="account-name"
								name="name"
								value={accountInfo ? accountInfo.name : undefined}
								validation={{
									required: 'Yetkili adı girmelisiniz.',
								}} />
						</div>
						<div className="col x6">
							<FormInput
								type="text"
								disabled={accountInfo === false || submitting}
								label="Yetkili Soyadı"
								autoComplete="account-surname"
								name="surname"
								value={accountInfo ? accountInfo.surname : undefined}
								validation={{
									required: 'Yetkili soyadı girmelisiniz.',
								}} />
						</div>
					</div>
					<div className="row">
						<div className="col x10">
							<FormInput
								type="email"
								disabled={accountInfo === false || submitting}
								label="E-Posta Adresi"
								autoComplete="account-email"
								name="email"
								value={accountInfo ? accountInfo.email : undefined}
								validation={{
									required: 'Bir e-posta adresi girmelisiniz.',
									email: true,
								}} />
						</div>
					</div>
					{accountInfo &&
						<div className="row">
							<div className="col x12">
								<FormInput
									disabled={submitting}
									type="checkbox"
									checked={changePassword}
									onChange={(val) => { setChangePassword(val ? true : false); }}
									value={1}
									label="Şifre değiştir" />
							</div>
						</div>
					}
					{changePassword &&
						<div className="row">
							<div className="col x6">
								<FormInput
									disabled={submitting}
									type="password"
									name="password"
									id="account_password"
									validation={{
										minLength: ['Şifreniz en az {length} karakterden oluşmalıdır.', 6]
									}}
									label="Yeni Şifre" />
							</div>
							<div className="col x6">
								<FormInput
									disabled={submitting}
									type="password"
									name="password_confirmation"
									id="account_password_new"
									validation={{
										minLength: ['Şifreniz en az {length} karakterden oluşmalıdır.', 6],
										compare: ['Girdiğiniz şifreler birbiriyle uyuşmuyor.', '#account_password']
									}}
									label="Yeni Şifre (Tekrar)" />
							</div>
						</div>
					}
					<div className="row">
						<div className="col x10">
							<FormInput
								slug
								type="text"
								disabled={accountInfo === false || submitting}
								readOnly={accountID}
								label="Kullanıcı Kodu"
								autoComplete="account-code"
								name="company_account_code"
								value={accountInfo ? accountInfo.company_account_code : undefined} />

							{!accountID &&
								<div className="form-note error">Kullanıcı kodu boş bırakılırsa rasgele bir kod atanır. Daha sonra değiştirilemez!</div>
							}
						</div>
					</div>
					{userData.is_owner &&
						<>
							<div className="row">
								<div className="col x10">
									<FormInput
										type="select"
										isSearchable
										disabled={accountInfo === false || submitting || !groups}
										label="Ödeme Grupları"
										z="5"
										multiple
										validation={{
											required: "Bir ödeme grubu seçmelisiniz."
										}}
										placeholder="Bir ödeme grubu seçin"
										options={groups}
										onChange={setUserGroups}
										name="store_codes"
										value={userGroups ? userGroups : []} />
								</div>
							</div>
							<div className="row">
								<div className="col x8 no-gap-top">
									<FormInput
										type="checkbox"
										disabled={accountInfo === false || submitting}
										checked={accountInfo && accountInfo.is_all_store === 1}
										label="Tüm Gruplara Ödeme Talebi Oluşturabilir"
										value="1"
										name="is_all_store" />
								</div>
							</div>
							<div className="row">
								<div className="col x8">
									<FormInput
										type="select"
										disabled={accountInfo === false || submitting || !(userGroups && userGroups.length)}
										label="Varsayılan Ödeme Grubu"
										z="4"
										validation={(userGroups && userGroups.length) ? {
											required: "Bir ödeme grubu seçmelisiniz."
										} : undefined}
										onChange={setDefaultUserGroup}
										placeholder="Bir ödeme grubu seçin"
										options={userGroups ? userGroups : []}
										name="default_store_code"
										value={defaultUserGroup} />
								</div>
							</div>
							{(accountInfo !== false && (!accountID || userData.id !== accountInfo.id)) &&
								<div className="row">
									<div className="col">
										<Collapser className="modal-group" title="Yetkiler" open disableToggle>
											<FormInput
												type="checkbox"
												disabled={accountInfo === false || submitting}
												checked={accountInfo && accountInfo.status === 1}
												label="Aktif"
												value="1"
												name="status" />

											{!terminalOption &&
												<FormInput
													type="checkbox"
													disabled={accountInfo === false || submitting}
													checked={ownerOption}
													onChange={(val) => { setOwnerOption(val ? true : false); }}
													label="Yönetici"
													value="1"
													name="is_owner" />
											}

											{!ownerOption &&
												<FormInput
													type="checkbox"
													disabled={accountInfo === false || submitting}
													checked={terminalOption}
													onChange={(val) => { setTerminalOption(val ? true : false); }}
													label="Terminal Kullanıcısı"
													value="1"
													name="is_terminal" />
											}

											{!ownerOption &&
												<React.Fragment>
													<FormInput
														type="checkbox"
														disabled={accountInfo === false || submitting}
														checked={accountInfo && accountInfo.is_super_user}
														label="Tüm Gruplarda Yetkili"
														value="1"
														name="is_super_user" />
														
													<FormInput
														type="checkbox"
														disabled={accountInfo === false || submitting}
														checked={accountInfo && accountInfo.is_group_report}
														label="Grup Raporu Yetkisi"
														value="1"
														name="is_group_report" />

													<FormInput
														type="checkbox"
														disabled={accountInfo === false || submitting}
														checked={accountInfo && accountInfo.is_group_clients}
														label="Sadece Grup Müşterileri"
														value="1"
														name="is_group_clients" />
												</React.Fragment>
											}
										</Collapser>
									</div>
								</div>
							}
						</>
					}
				</div>
			</div>

			<div className="modal-controls">
				<Btn
					nude
					disabled={submitting}
					onClick={close}>
					Vazgeç
				</Btn>
				<Btn
					loading={submitting}
					disabled={submitting || accountInfo === false}
					type="submit">
					{accountID ? 'Kaydet' : 'Oluştur'}
				</Btn>
			</div>
		</InputForm>
	)
}

const ConnectedModal = connect(mapStateToProps)(AccountModal);

ConnectedModal.defaultProps = {
	className: '',
	containerClass: 'modal-account mobile-full',
	name: 'account',
	accountID: false,
}

export default ConnectedModal